import { YesNoEmpty } from '@interfaces/models';
import { createAction, props } from '@ngrx/store';

export const UpdateIsCrewOnMultiTransactionFlow = createAction(
  '[Update Is Crew Multi Transaction Flow] Triage: Update Is Crew On Multi Transaction Flow',
  props<{ payload: YesNoEmpty }>(),
);
